import { TryPageTemplate } from '@/templates/try/try-page/src/try-page.template';

export const TryPage = () => <TryPageTemplate />;
